import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Box, Typography, Switch, FormControlLabel, alpha, useTheme } from '@mui/material';
import { Iconify } from '../../../components';

const CHANNELS = [
  { key: 'email', label: 'Email Marketing', icon: 'formkit:email', field: 'email_marketing_consent', color: 'info.main' },
  { key: 'whatsapp', label: 'WhatsApp Marketing', icon: 'ic:baseline-whatsapp', field: 'whatsapp_marketing_consent', color: '#25D366' },
  { key: 'sms', label: 'SMS Marketing', icon: 'material-symbols:sms', field: 'sms_marketing_consent', color: 'text.secondary' },
];

export default function MarketingPreferences({ lead, onUpdate }) {
  const theme = useTheme();
  const [consents, setConsents] = useState({
    email_marketing_consent: lead?.email_marketing_consent ?? true,
    whatsapp_marketing_consent: lead?.whatsapp_marketing_consent ?? true,
    sms_marketing_consent: lead?.sms_marketing_consent ?? true,
  });

  const handleToggle = (field, value) => {
    setConsents((prev) => ({ ...prev, [field]: value }));
    if (onUpdate) onUpdate({ [field]: value });
  };

  return (
    <Box sx={{ mb: 3 }}>
      <Typography variant="subtitle2" sx={{ mb: 1.5, display: 'flex', alignItems: 'center', gap: 0.75 }}>
        <Iconify icon="mdi:bell-ring" width={18} />
        Marketing Preferences
      </Typography>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        {CHANNELS.map((ch) => (
          <Box
            key={ch.key}
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              p: 1.5,
              borderRadius: 1,
              border: `1px solid ${alpha(theme.palette.grey[500], 0.16)}`,
              bgcolor: consents[ch.field] ? 'transparent' : alpha(theme.palette.error.main, 0.04),
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Iconify icon={ch.icon} width={20} sx={{ color: ch.color }} />
              <Typography variant="body2">{ch.label}</Typography>
            </Box>
            <FormControlLabel
              control={
                <Switch
                  checked={consents[ch.field]}
                  onChange={(e) => handleToggle(ch.field, e.target.checked)}
                  color={consents[ch.field] ? 'success' : 'error'}
                  size="small"
                />
              }
              label=""
              sx={{ m: 0 }}
            />
          </Box>
        ))}
      </Box>
      {Object.values(consents).some((v) => !v) && (
        <Typography variant="caption" sx={{ color: 'text.secondary', mt: 1, display: 'block' }}>
          Opted-out channels will be excluded from future campaign audiences.
        </Typography>
      )}
    </Box>
  );
}

MarketingPreferences.propTypes = {
  lead: PropTypes.object,
  onUpdate: PropTypes.func,
};

MarketingPreferences.defaultProps = {
  lead: {},
  onUpdate: null,
};
